// extracted by mini-css-extract-plugin
module.exports = {"emailContainer":"EmailContainer_emailContainer__Nii-s","titleContainer":"EmailContainer_titleContainer__31TzW"};